const toBoolean = (str) => {
  return (str === 'true' || str === true)
}

export default toBoolean
